import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class LocalTrabajadorRepository {

    constructor() {
    }

    /**
     * Datos de sesión
     */


    public obtenerToken() {
        return localStorage.getItem('token');
    }

    public guardarToken(token: string) {
        localStorage.setItem('token', token);
    }

    public eliminarToken() {
        localStorage.removeItem('token');
    }


    // public guardarTrabajadorSesion(trabajadorObj: Trabajador) {
    public guardarTrabajadorSesion(trabajadorObj: any) {
        localStorage.setItem('trabajadorSesion', JSON.stringify(trabajadorObj));
    }

    public guardarDNI(dni: string) {
        localStorage.setItem('dni', dni);
    }

    public getDNI(): string {
        return localStorage.getItem('dni');
    }

    public eliminarTrabajadorSesion() {
        localStorage.removeItem('trabajadorSesion');
    }
}
